/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Even_Bold_Jackdaw_HarborInputs */

const fr_even_bold_jackdaw_harbor = /** @type {(inputs: Even_Bold_Jackdaw_HarborInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinitialiser mon mot de passe`)
};

/**

* @param {Even_Bold_Jackdaw_HarborInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const even_bold_jackdaw_harbor = /** @type {((inputs?: Even_Bold_Jackdaw_HarborInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Even_Bold_Jackdaw_HarborInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_even_bold_jackdaw_harbor(inputs)
});